import React, { useContext, VFC } from 'react';

import classNames from 'classnames';
import { Text } from 'mintel-react-ui';

import { HTMLContentJson, PresentOption } from '../../types';
import {
  BlockBackgroundContext,
  PresentModeContext,
} from '../../utils/contexts';
import { contentFilter } from '../../utils/functions';
import styles from './BlockQuadrant.scss';

type QuadrantCellProps = {
  cell: {
    title?: HTMLContentJson;
    content: HTMLContentJson;
  };
  index: number;
  animationStep: number;
  animationEnabled: boolean;
  presentOption?: PresentOption;
};

const QuadrantCell: VFC<QuadrantCellProps> = ({
  cell,
  presentOption,
  index,
  animationStep,
  animationEnabled,
}) => {
  const presentMode = useContext(PresentModeContext);
  const { darkBg } = useContext(BlockBackgroundContext);

  const body = contentFilter(cell.content, presentMode, presentOption);
  return (
    <div
      className={classNames(styles.cell, {
        [styles.hide]: animationEnabled && animationStep <= index,
      })}
    >
      {!!cell?.title && !!cell.title.content && !cell.title.hidden && (
        <Text.Heading4 darkBg={darkBg}>
          <h4 dangerouslySetInnerHTML={{ __html: cell.title.content }}></h4>
        </Text.Heading4>
      )}
      {!!body && (
        <Text.Body darkBg={darkBg} underlineLinks>
          <div dangerouslySetInnerHTML={{ __html: body }} />
        </Text.Body>
      )}
    </div>
  );
};

export default QuadrantCell;
